export const key = "AIzaSyC4wwIGvOOYBzHrgCOZnul9wbJf5puShQI";
export const calendarId =
  "nology.io_5smheaincm2skd1tcmvv7m37d8@group.calendar.google.com";
